import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import UploadPopup from '../popups/file-upload/UploadPopup';
import { fileUploadVariablesType } from '../../types';
import { joinClassNames } from '../../utils';

UploadButton.propTypes = {
    label: PropTypes.string.isRequired,
    uploadPath: PropTypes.string.isRequired,
    className: PropTypes.string,
    multiple: PropTypes.bool,
    accept: PropTypes.string,
    baseVariables: fileUploadVariablesType,
    extraVariablesComp: PropTypes.func,
    responseComp: PropTypes.func,
    disabled: PropTypes.bool,
    onUpload: PropTypes.func,
    extraConfirmationMessage: PropTypes.string,
    children: PropTypes.node,
};

UploadButton.defaultProps = {
    className: null,
    multiple: false,
    accept: null,
    baseVariables: [],
    extraVariablesComp: null,
    responseComp: null,
    disabled: false,
    onUpload: null,
    extraConfirmationMessage: null,
    children: null,
};

function UploadButton(props) {
    const {
        label,
        className,
        uploadPath,
        accept,
        multiple,
        baseVariables,
        extraVariablesComp,
        responseComp,
        disabled,
        onUpload,
        extraConfirmationMessage,
        children,
    } = props;
    const [isPopupVisible, setPopupVisible] = useState(false);
    const onClickHandler = () => setPopupVisible(true);
    const onCancelHandler = () => setPopupVisible(false);
    return (
        <>
            <button
                type="button"
                className={joinClassNames('upload-button', 'button', className)}
                onClick={onClickHandler}
                title={label}
                disabled={disabled}
            >
                <FontAwesomeIcon icon="upload" />&nbsp;{label}
            </button>
            {isPopupVisible && (
                <UploadPopup
                    title={label}
                    onCancel={onCancelHandler}
                    uploadPath={uploadPath}
                    multiple={multiple}
                    accept={accept}
                    baseVariables={baseVariables}
                    extraVariablesComp={extraVariablesComp}
                    responseComp={responseComp}
                    onUpload={onUpload}
                    extraConfirmationMessage={extraConfirmationMessage}
                >
                    {children}
                </UploadPopup>
            )}
        </>
    );
}

export default UploadButton;
